import * as React from 'react';
import { useResizeObserver } from './useResizeObserver';

/**
 * Given a ref for an HTMLElement, stores that element's DOMRect and tracks changes to it.
 *
 * Note that if only needing to update state based on certain changes or specific sizes, it'll be better to
 * use useResizeObserver directly, as this will update component state every time the rectangle changes size
 * instead of just calling your resizeCallback, which can cause performance issues.
 */
export function useElementSizeTracker(ref: React.RefObject<HTMLDivElement>) {
    const [rect, setRect] = React.useState<DOMRectReadOnly | undefined>();
    const resizeCallback = React.useCallback((rect: DOMRectReadOnly) => {
        setRect(rect);
    }, []);
    React.useLayoutEffect(() => {
        const rect = ref.current?.getBoundingClientRect?.();
        setRect(rect);
    }, []);
    useResizeObserver(ref, resizeCallback);

    return [rect] as const;
}
